import React, { useState } from 'react'
import Paper from '@mui/material/Paper'
import InputBase from '@mui/material/InputBase'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import { Icon } from '@iconify/react'

interface AskBarProps {
  callback: (message: string) => void,
  theme: string
}

export default function CustomizedInputBase({ callback, theme }: AskBarProps) {
  const [question, setQuestion] = useState('')

  function handleSend() {
    callback(question)
    setQuestion('')
  }

  function handleChange(value: string) {
    setQuestion(value)
    if (value[value.length - 1] === '\n') {
      handleSend()
    }
  }

  return (
    <Paper component='form' sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%', backgroundColor: theme === 'dark' ? '#283046' : 'white' }}>
      <InputBase
        sx={{ ml: 1, flex: 1, backgroundColor: theme === 'dark' ? '#283046' : 'white' }}
        style={{color: theme === 'dark' ? 'white' : 'black'}}
        placeholder={localStorage.getItem('i18nextLng') === 'fr-FR' ? 'Tapez votre question ici' : 'Type your question here'}
        inputProps={{ 'aria-label': 'Type your question here', color: 'red' }}
        value={question}
        onChange={(e) => handleChange(e.target.value)}
        fullWidth
        multiline
      />
      <Divider sx={{ height: 28, m: 0.5 }} orientation='vertical' />
      <IconButton color='primary' sx={{ p: '10px' }} aria-label='ask' onClick={handleSend}>
        <Icon icon='iconamoon:send-thin' />
      </IconButton>
    </Paper>
  )
}
